import React, { useState } from 'react';
import CreateDialogueExercise from './CreateDialogueExercise';
import './CreateDialogueExerciseBoard.css';

const CREATE_DIALOGUE_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #fb7185 0%, #ffabaf 100%)', marginRight: 20, flexShrink: 0
  }}>
    <svg width="28" height="28" viewBox="0 0 16 16" fill="white">
      <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
      <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
  </span>
);

const CreateDialogueExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { dialogue, title, level, topic } = exerciseData;

  if (!dialogue) {
    return (
      <div className="create-dialogue-board-error">
        <p>Error: Invalid Create Dialogue exercise data</p>
      </div>
    );
  }

  const handleExpand = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(true);
    if (onSelect) onSelect();
    if (onExpand) onExpand();
  };

  const handleClose = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(false);
    if (onClose) onClose();
  };

  return (
    <div className="create-dialogue-exercise-board">
      {!isExpanded ? (
        <div
          className={`create-dialogue-preview unified-exercise-preview cd-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={handleExpand}
        >
          {CREATE_DIALOGUE_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Create Dialogue Exercise'}</div>
            <div className="unified-preview-meta">
              {dialogue.length} dialogue lines · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="create-dialogue-expanded">
          <CreateDialogueExercise
            dialogue={dialogue}
            title={title}
            level={level}
            topic={topic}
            onClose={handleClose}
            updateAttributes={onUpdate}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default CreateDialogueExerciseBoard;
